<template>
  <div>
  </div>
</template>

<script>
import { apiAccount } from '../../Api/api'
import $ from 'jquery'
export default {
  props: {
    id: {
      type: String,
      default: ''
    },
    token: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      RegToken: '',
      Data: {}
    }
  },
  created () {
    this.CheckToken()
  },
  methods: {
    CheckToken () { // 啟用 F_API 005
      // 定義資料
      const vm = this
      vm.Data.UserId = vm.id
      vm.Data.RegToken = vm.token
      vm.Data.APIVer = '0'
      vm.Data.ClientIP = '0.0.0.0'
      // 呼叫API
      apiAccount(vm.Data).then(
        res => {
          if (res !== undefined) {
            localStorage.removeItem('Registry')
            vm.$bus.$emit('Modals', '帳號認證成功')
            $('#CheckOk').modal('show')
            vm.$router.push({ name: 'Home_News' })
          } else {
            vm.$bus.$emit('Modals', '認證錯誤')
            $('#CheckError').modal('show')
            vm.$router.push({ name: 'Home_News' })
          }
        }
      )
    }
  }
}
</script>
